// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"CL-z","inlineTitle":"DL-z","sponsoredAdsWrapper":"EL-z","marketplaceRecosWrapper":"FL-z"};